import { configureStore } from '@reduxjs/toolkit'
// import thunk from 'redux-thunk';
// import logger from 'redux-logger';
import { reduces } from './reduce';

export const store = configureStore({
    reducer: {
        localesSlice: reduces.localesSlice.reducer,
        localesReducer: reduces.localesSlice.reducer,
        scrollNumReducer: reduces.scrollNumSlice.reducer,
        recReSizeReducer: reduces.recReSizeSlice.reducer,
        viewrSliceReducer: reduces.viewrSlice.reducer,
    },
    // middleware: [thunk, logger],
});
